export {default as chord} from "./src/chord";
export {default as ribbon} from "./src/ribbon";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-chord/index.js
// module id = 347
// module chunks = 0